import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

import { Button, ButtonIcon } from 'rmwc/Button';
import SerializeForm from 'form-serialize'
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Grid, GridCell } from 'rmwc/Grid';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import StatusMessage from '../util/StatusMessage'


class PasswordReset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      errorMsg: '',
      errorMsgUserName: '',
      data: {
        password: '',
        password_confirmation:'',
        userName: ''
      },
      formErrors: {
        passwordError:'',
        confirmPasswordError:'',
        userNameError:''
      }

    }

    this.validateForm = this.validateForm.bind(this);
    this.validateFormUserName = this.validateFormUserName.bind(this);
  }


  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    data.userName = this.props.user.userName
    this.setState({data: data})
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.passwordError = ''
    errorObj.confirmPasswordError = ''

    if(data.password === ''){
      errorObj.passwordError ='Password is mandatory'
      error = false
    }

    if(data.password_confirmation === ''){
      errorObj.confirmPasswordError ='Confirm Password is mandatory'
      error = false
    }

    if(data.password_confirmation !== data.password){
      errorObj.confirmPasswordError ='Password and confirm password should match'
      error = false
    }

    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })
    return error

  }

  validateFormUserName(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.userNameError = ''

    if(data.userName === ''){
      console.log('inside user name mandatory')
      errorObj.userNameError ='User Name is Mandatory'
      error = false
    }

    if(data.userName === this.props.user.userName){
      errorObj.userNameError ='Modified User Name is same as existing User Name'
      error = false
    }    

    this.setState({
      formErrors:errorObj,
      errorMsgUserName:''
    })
    return error    

  }  

  handleSubmit = evt => {
    evt.preventDefault()
    console.log('insdie submit of reset')
    let data = Object.assign({}, this.state.data)
    if(this.validateForm()){
      
      let apiInput = {
       'user_name': this.props.user.userName,
       'user': {
         'password': this.state.data.password,
         'password_confirmation': this.state.data.password_confirmation    
        }
      }

      api.resetPassword(this.props.user.accessToken,apiInput)
        .then((result) => {
          if(result.errors){
            this.setState({ errorMsg: result.errors })
          }
          else{
            this.setState({ errorMsg: 'Successfully Changed Password' })
          }
          })
          .catch((err) => {
            this.setState({ errorMsg: err.stack })
          })  
    }
  };

  handleUserNameReset = evt => {
    evt.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(this.validateFormUserName()){
      
      let apiInput = {
       'user_name_existing': this.props.user.userName,
       'user': {
         'user_name': this.state.data.userName            
        }
      }

      api.resetUserName(this.props.user.accessToken,apiInput)
        .then((result) => {
          if(result.status === 'success'){
            console.log(this.props.user.id)
            this.setState({ errorMsgUserName: 'User Name updated successfully' })
            const obj = {}
            obj.accessToken = this.props.user.accessToken            
            obj.userName = this.state.data.userName
            obj.id = this.props.user.id
            obj.role = this.props.user.role
            this.props.userLogin(obj)

          }
          else{
            this.setState({ errorMsgUserName: result.data })
          }
          })
          .catch((err) => {
            this.setState({ errorMsgUserName: err.stack })
          })  
    }
  };

  render(){

    return (
      <Grid>
        <GridCell span="12">
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
                <Typography use="headline5">Password Reset</Typography>
                <Grid className="opportunity-list-item">
                  <GridCell span="6">
                    <FormField className="opportunity-form-field">
                      <TextField fullwidth type="password" className='text_input' label="Password" autoComplete="off" name="password" onChange={this.onInputChange} value={this.state.data.password}/>
                    </FormField>
                  </GridCell>
                  <GridCell span="6">
                     <FormField className="opportunity-form-field">
                       <TextField fullwidth type="password" className='text_input' label="Confirm Password" autoComplete="off"  name="password_confirmation" onChange={this.onInputChange} value={this.state.data.password_confirmation}/>
                     </FormField>   
                  </GridCell>
            
                  <GridCell span="12" className="button-section">
                    <Button raised theme="secondary-bg on-secondary">Update</Button>
        
                  </GridCell>
                </Grid>
                <GridCell span="12" className="button-section">
                </GridCell>
                  <StatusMessage error_msg = {this.state.errorMsg}/>
                  <StatusMessage error_msg = {this.state.formErrors.passwordError}/>
                  <StatusMessage error_msg = {this.state.formErrors.confirmPasswordError}/>
            </Card>
          </form>  
      </GridCell>

      <GridCell span="12">
          
            <Card style={{padding: '25px'}}>
                <Typography use="headline5">User Name Reset</Typography>
                <Grid className="opportunity-list-item">
                  <GridCell span="6">
                    <FormField className="opportunity-form-field">
                      <TextField fullwidth className='text_input' label="User Name" autoComplete="off" name="userName" onChange={this.onInputChange} value={this.state.data.userName}/>
                    </FormField>
                  </GridCell>
                  <GridCell span="6">
                      
                  </GridCell>
            
                  <GridCell span="12" className="button-section">
                    <Button raised theme="secondary-bg on-secondary" onClick={this.handleUserNameReset}>Update</Button>
        
                  </GridCell>
                </Grid>
                <GridCell span="12" className="button-section">
                </GridCell>
                  <StatusMessage error_msg = {this.state.errorMsgUserName}/>
                  <StatusMessage error_msg = {this.state.formErrors.userNameError}/>
            </Card>

      </GridCell>


    </Grid>

      )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset); 


// WEBPACK FOOTER //
// ./src/views/PasswordReset.jsx